import React from "react";
import { Box, Typography } from '@curves/ui-base';

import { isEmpty } from "@Util/utils";
const ChangeRecordCardMain = ({ title, descList = [] }) => {
	return (
		<Box className="">
			<Typography variant="h6" className="font-weight-bold">
				{title || "無標題"}
			</Typography>
			{!isEmpty(descList) &&
				descList.map((item, index) => (
					<Typography key={index} variant="body2">
						{item.label ? `${item.label}: ${item.text}` : item.text}
					</Typography>
				))}
		</Box>
	);
};
export default ChangeRecordCardMain;
